import { defineComponent as _defineComponent } from 'vue'
import { Studio, StudioUser, SearchParams } from '@/modules/Studios/types'
import { ref, watch, onMounted } from 'vue'
import { mdiChevronDown, mdiChevronUp } from '@mdi/js'
import StudioMemberChip from '@/modules/Studios/components/tabs/StudioMemberChip.vue'
import { fetchStudioTeachers } from '@/enitites/studio/api/endpoints'
import Bugsnag from '@bugsnag/js'


export default /*#__PURE__*/_defineComponent({
  __name: 'StudioTeachersTab',
  props: {
    studio: null
  },
  setup(__props: any) {

const props = __props as {
  studio: Studio | undefined
};



const teachers = ref<StudioUser[]>([])
const loading = ref(false)
const sortBy = ref<'name'>('name')
const sortDirection = ref<'asc' | 'desc'>('asc')
const pageNumber = ref(0)
const pageSize = ref(100) // Adjust as needed
const keyword = ref('')

const fetchTeachers = async () => {
  if (!props.studio?.id) return

  loading.value = true
  try {
    const params: SearchParams = {
      pageNumber: pageNumber.value,
      pageSize: pageSize.value,
      keyword: keyword.value,
      sortBy: sortBy.value,
      sortDir: sortDirection.value,
    }

    const fetchedTeachers = await fetchStudioTeachers(props.studio.id, params)
    teachers.value = fetchedTeachers || []
  } catch (error) {
    Bugsnag.notify(error instanceof Error ? error : new Error(String(error)), (event) => {
      event.addMetadata('studio', {
        context: 'Error fetching studio teachers',
        studioId: props.studio?.id,
        searchParams: {
          pageNumber: pageNumber.value,
          pageSize: pageSize.value,
          keyword: keyword.value,
          sortBy: sortBy.value,
          sortDir: sortDirection.value,
        },
      })
    })
    teachers.value = []
  } finally {
    loading.value = false
  }
}

watch([sortBy, sortDirection], () => {
  fetchTeachers()
})

watch(
  () => props.studio?.id,
  () => {
    if (props.studio?.id) {
      fetchTeachers()
    }
  },
  { immediate: true }
)

onMounted(() => {
  if (props.studio?.id) {
    fetchTeachers()
  }
})

return { __sfc: true,props, teachers, loading, sortBy, sortDirection, pageNumber, pageSize, keyword, fetchTeachers, mdiChevronDown, mdiChevronUp, StudioMemberChip }
}

})